import { render, staticRenderFns } from "./BillingFreezeNotice.vue?vue&type=template&id=5c534752&"
import script from "./BillingFreezeNotice.vue?vue&type=script&lang=ts&"
export * from "./BillingFreezeNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports